import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import { useId } from '../helper';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5155 19.5305H42.9898L45.2618 24.4772H45.464L47.736 19.5305H50.2103V27.8994H48.6386V22.5327L48.7631 21.3505H48.6386L46.5067 25.9394H44.2347L42.1027 21.3505H41.9627L42.1027 22.5327V27.8994H40.5155V19.5305Z",
  fill: "#212429"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0073 19.3438H57.8354L60.2164 27.8994H58.5979L58.0378 25.8305H53.8206L53.2604 27.8994H51.642L54.0073 19.3438ZM57.602 24.2594L56.6839 20.9149H55.1433L54.2252 24.2594H57.602Z",
  fill: "#212429"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.399 19.3438H65.554C67.5303 19.3438 68.8531 20.7127 68.8531 22.1905C68.8531 23.1549 68.3551 23.8082 67.8727 24.2282C67.577 24.4771 67.2502 24.6638 66.8923 24.8194L68.7908 27.8838H66.8923L65.1338 25.0371H63.0175V27.8838H61.399V19.3438ZM65.554 23.4816C66.6278 23.4816 67.1724 22.9216 67.1724 22.206C67.1724 21.4905 66.6278 20.9305 65.554 20.9305H63.0175V23.4971H65.554V23.4816Z",
  fill: "#212429"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4714 19.3438H72.0898V22.766H73.7082L76.0269 19.3438H77.8476L75.0465 23.4816L78.0654 27.8994H76.167L73.7704 24.3371H72.0898V27.8994H70.4714V19.3438Z",
  fill: "#212429"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1237 19.3438H85.4416V20.9149H80.742V22.766H84.6013V24.3371H80.742V26.3282H85.4416V27.8994H79.1237V19.3438Z",
  fill: "#212429"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0796 19.3438H93.7359V20.9149H90.717V27.8994H89.0985V20.9149H86.0796V19.3438Z",
  fill: "#212429"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M96.4903 19.3438H94.8719V27.8994H96.4903V19.3438Z",
  fill: "#212429"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M98.451 19.3438H100.63L104.504 25.7527H104.645L104.504 24.6171V19.3438H106.123V27.8994H103.929L100.069 21.4749H99.9294L100.069 22.626V27.8994H98.451V19.3438Z",
  fill: "#212429"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M112.379 19.0639C114.168 19.0639 115.273 19.8416 115.942 20.635C116.316 21.0861 116.611 21.615 116.814 22.2061H115.195C115.04 21.8794 114.837 21.5994 114.588 21.3505C114.153 20.915 113.452 20.495 112.379 20.495C110.698 20.495 109.36 21.8639 109.36 23.6217C109.36 25.3794 110.698 26.7483 112.379 26.7483C113.499 26.7483 114.215 26.2505 114.651 25.7528C114.9 25.4572 115.102 25.1305 115.258 24.7572H113.857V23.1861H118.074V24.7572H116.876C116.658 25.395 116.362 25.9705 115.989 26.4683C115.335 27.3394 114.199 28.1794 112.379 28.1794C109.702 28.1794 107.664 26.1105 107.664 23.6217C107.664 21.1328 109.702 19.0639 112.379 19.0639Z",
  fill: "#212429"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M70.736 11.9395C70.8294 12.2661 70.9849 12.5617 71.2183 12.8106C71.6385 13.2461 72.3077 13.6661 73.5371 13.6661C75.3422 13.6661 76.0736 12.935 76.0736 12.2194C76.0736 11.0683 74.3151 10.7883 72.5411 10.415C70.7671 10.0417 69.0086 9.295 69.0086 7.24167C69.0086 5.515 70.5492 3.99057 73.4437 3.99057C75.4667 3.99057 76.6493 4.79946 77.3185 5.6239C77.7231 6.10613 77.9876 6.65057 78.1588 7.25724H75.9802C75.8868 7.0239 75.7468 6.79056 75.5289 6.58834C75.171 6.24612 74.533 5.90389 73.4437 5.90389C71.7942 5.90389 71.1873 6.44833 71.1873 7.16389C71.1873 7.97278 72.1832 8.36167 73.4125 8.61056C75.4978 9.03056 78.2522 9.52833 78.2522 12.1417C78.2522 13.9461 76.6338 15.5795 73.5371 15.5795C71.234 15.5795 69.9579 14.6928 69.2576 13.775C68.853 13.2461 68.5885 12.6394 68.464 11.9706H70.736V11.9395Z",
  fill: "#212429"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7969 4.33273H88.6629V6.32385H84.7725V15.2061H82.6873V6.32385H78.7969V4.33273Z",
  fill: "#212429"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0858 10.5861L94.9031 6.3394H92.9112L91.7285 10.5861H96.0858ZM91.4484 4.33273H96.3814L99.4471 15.1905H97.3618L96.6304 12.5616H91.1995L90.468 15.1905H88.3828L91.4484 4.33273Z",
  fill: "#212429"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M99.1669 4.33273H109.033V6.32385H105.142V15.2061H103.057V6.32385H99.1669V4.33273Z",
  fill: "#212429"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M112.565 4.33273H110.48V15.1905H112.565V4.33273Z",
  fill: "#212429"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M120.626 13.5728C122.883 13.5728 124.517 11.9394 124.517 9.77721C124.517 7.59943 122.883 5.98165 120.626 5.98165C118.37 5.98165 116.736 7.61498 116.736 9.77721C116.736 11.9394 118.37 13.5728 120.626 13.5728ZM120.626 3.97498C124.159 3.97498 126.695 6.51054 126.695 9.76165C126.695 13.0128 124.159 15.5483 120.626 15.5483C117.094 15.5483 114.557 13.0128 114.557 9.76165C114.557 6.51054 117.094 3.97498 120.626 3.97498Z",
  fill: "#212429"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M128.687 4.33273H131.488L136.468 12.4838H136.655L136.468 11.0372V4.33273H138.553V15.2061H135.752L130.772 7.05496H130.586L130.772 8.50163V15.2061H128.687V4.33273Z",
  fill: "#212429"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M46.4134 9.45054H43.9857V6.82165H46.4134C47.2537 6.82165 47.8917 7.38165 47.8917 8.12832C47.8917 8.87499 47.2692 9.45054 46.4134 9.45054ZM49.4168 11.4728C49.7747 11.3017 50.117 11.0528 50.4127 10.7261C51.0974 10.0261 51.4398 9.15498 51.4398 8.14387C51.4398 5.68609 49.5101 3.97498 46.7557 3.97498H40.5311V15.5639H43.9857V12.2194H46.1021L47.9851 15.5639H51.4709L49.2144 11.5661L49.4168 11.4728Z",
  fill: "#212429"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M56.6684 12.6239V6.91498H57.9756C59.7963 6.91498 60.9167 8.00388 60.9167 9.76165C60.9167 11.5194 59.7963 12.6083 57.9756 12.6083H56.6684V12.6239ZM64.5425 9.76165C64.5425 6.40165 61.8192 3.97498 58.0689 3.97498H53.2137V15.5639H58.0689C61.8192 15.5639 64.5425 13.1217 64.5425 9.76165Z",
  fill: "#212429"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 23.2159L32.0123 29.1386V23.8282L15.9999 17.9055L0 23.8282V29.1386L15.9999 23.2159Z",
  fill: "#212429"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 23.216L0 29.1386L5.93887 32L15.9999 28.2765L26.0734 32L32.0123 29.1386L15.9999 23.216Z",
  fill: "#19C1CE"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 8.78409L0 2.86136V8.17178L15.9999 14.0945L32.0123 8.17178V2.86136L15.9999 8.78409Z",
  fill: "#212429"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9999 8.7841L32.0123 2.86137L26.0734 0L15.9999 3.72358L5.93887 0L0 2.86137L15.9999 8.7841Z",
  fill: "#19C1CE"
});

function RDStationMarketing(_ref) {
  let {
    title,
    titleId: titleIdProp
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "titleId"]);

  const titleId = useId(titleIdProp);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139",
    height: "32",
    viewBox: "0 0 139 32",
    fill: "none",
    "arial-label": 'RD Station Marketing',
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

RDStationMarketing.defaultProps = {
  title: 'RD Station Marketing logo'
};
process.env.NODE_ENV !== "production" ? RDStationMarketing.propTypes = {
  titleId: PropTypes.string,
  title: PropTypes.string
} : void 0;
export default RDStationMarketing;